<kendo-card class="fastlinkmoni-card" *ngIf="veldStationBluePrint">
  <kendo-card-header class="k-hstack">
    <div>
      <h1 class="offline" *ngIf="TestOffLine(); else OnLine"  kendoCardTitle><kendo-icon name="error"></kendo-icon> Veldstation {{ Unzerobase(veldStationBluePrint.station) }} OFFLINE</h1>
      <ng-template #OnLine>
        <h1  kendoCardTitle><kendo-icon name="home"></kendo-icon> Veldstation {{ Unzerobase(veldStationBluePrint.station) }} </h1>
      </ng-template>
      <p kendoCardSubtitle> Status {{ GetStatusString(veldStationRunTime ? veldStationRunTime.status : 0) }} </p>
      <p *ngIf="GetNewVeldStation()" kendoCardSubtitle> NEW STATION </p>
    </div>
  </kendo-card-header>
  <hr kendoCardSeparator/>
  <kendo-card-body>


    <div *ngFor='let count of Counter(64) ;let i = index'>
      <app-fast-link-fast-link [offline] = "TestOffLine()"
                               [fastLinkBluePrint]="FindBluePrint(i)"
                               [fastLinkRunTime]="FindRunTime(i)">
      </app-fast-link-fast-link>
    </div>


<!--    <div *ngFor="let fastLinkRunTime of fastLinkListRunTime">-->
<!--      <app-fast-link-fast-link *ngIf="veldStationBluePrint.station == StationNr(fastLinkRunTime.nummerVeldstation)"-->
<!--                               [offline] = "TestOffLine()"-->
<!--                               [fastLinkBluePrint]="fastLinkRunTime"-->
<!--                               [fastLinkRunTime]="FindRunTime(fastLinkRunTime.fastlinkstation)">-->
<!--      </app-fast-link-fast-link>-->
<!--    </div>-->



  </kendo-card-body>

  <kendo-card-footer >
  </kendo-card-footer>

</kendo-card>





